export const userStateKey = 'user';
export const userRoleSelectorKey = 'role';
export const userOwnerTypeSelectorKey = 'ownerType';
export const editableFormStateKay = 'editableForm';
